import { render, staticRenderFns } from "./Comentarios.vue?vue&type=template&id=4083351e&scoped=true&"
import script from "./Comentarios.vue?vue&type=script&lang=js&"
export * from "./Comentarios.vue?vue&type=script&lang=js&"
import style0 from "./Comentarios.vue?vue&type=style&index=0&id=4083351e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4083351e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
